// Module
var code = "<nova-pie-chart showlegend=\"{{vm.showLegend}}\" showtotal=\"{{vm.showTotal}}\" cutout=\"{{:: vm.isDonut ? '75%' : '0'}}\" data=\"[]\"></nova-pie-chart>\r\n";
// Exports
export default code;